<template>
  <div>
    <a-row>
          <g-master name="forms"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    @action="masterAction"
                    ref="master"
                    :parentData="ParentData"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('ID action')">
                    <a-input
                      v-decorator="['id_action', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown v-bind="fiOptions"
                              endpoint="node"
                              :label="$t('Item')"
                              :formItemConfig="fiOptions"
                              :decorator="['item', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown v-bind="fiOptions"
                              endpoint="hierarchy_lookup"
                              :label="$t('Estado')"
                              :formItemConfig="fiOptions"
                              :decorator="['status', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                              :params="status">
                  </g-dropdown>
                </a-col>
              </a-row>
            </template>
          </g-master>
    </a-row>
    <a-row>
    </a-row>

    <!-- NUEVO MODAL -->
    <a-modal
      :visible="visible"
      title='Crear / Editar'
      okText='Ok'
      :confirm-loading="loading"
      @cancel="() => (visible = false)"
      @ok="editarRoleNodeAction()"
    >
      <a-form-model :model="iRoleNodeAction" v-bind="fiOptions" :rules="formRules"
                    @submit.native.prevent ref="valdicRoleNodeAction">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <a-form-model-item :label="$t('Estado')" prop="status" has-feedback>
              <form-model-dropdown style="width: 100%"
                                   v-model="iRoleNodeAction.status"
                                   endpoint="hierarchy_lookup"
                                   :params="status"
              >
              </form-model-dropdown>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    props: ['name'],
    computed: {
      ParentData () {
        return {
          role_name: this.name
        }
      }
    },
    data () {
      return {
        visible: false,
        iRoleNodeAction: {},
        loading: false,
        formRules: {},
        status: {
          h_lookup_type: 'ESTADO_ACT_INA',
          use_code: true
        },
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'role_node_action',
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'editar',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'customDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                }
              ]
            },
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'ID', dataIndex: 'id_action', sorter: true},
              {title: 'Item', dataIndex: 'item', sorter: true},
              {title: 'Estado', dataIndex: 'status_desc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_action'},
            {name: 'item'},
            {name: 'status'}
          ]
        }
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'customDelete':
            this.$confirm({
              title: 'Confirmación',
              content: '¿Está seguro que desea eliminar el registro?',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.httpClient.getInstance().delete('role_node_action/rnd', {
                    data: action.record
                  })
                    .then(() => {
                      this.$refs.master.$refs.datatable.loadData()
                      resolve()
                    })
                    .catch((error) => {
                      Mensajes.error('Error', 'No fue posible eliminar el registro')
                      reject(error)
                    })
                })
              },
              onCancel () { }
            })
            break
          case 'editar':
            this.visible = true
            this.iRoleNodeAction = {...action.record}
            break
        }
      },
      initFormRules () {
        this.formRules = {
          id_action: [{required: true, message: 'Valor requerido'}],
          item: [{required: true, message: 'Valor requerido'}],
          role_name: [{required: true, message: 'Valor requerido'}]
        }
      },
      editarRoleNodeAction () {
        this.loading = true
        this.$refs.valdicRoleNodeAction.validate(valid => {
          if (valid) {
            return new Promise((resolve, reject) => {
              this.httpClient.getInstance().put('role_node_action/act', {
                id_action: this.iRoleNodeAction.id_action,
                item: this.iRoleNodeAction.item,
                role_name: this.iRoleNodeAction.role_name,
                status: this.iRoleNodeAction.status
              })
                .then(() => {
                  this.$refs.master.$refs.datatable.loadData()
                  resolve()
                  this.loading = false
                  this.visible = false
                })
                .catch((error) => {
                  Mensajes.error('Error', 'No fue posible actualizar')
                  reject(error)
                  this.loading = false
                  this.visible = false
                })
            })
          }
        })
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.initFormRules()
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/User/RoleNodeAction.vue